import { courseContentReviewRoutesDefinitions } from '@/routes-definitions';

export const courseContentReviewRoutes = [
  {
    path: courseContentReviewRoutesDefinitions.contentReview.path,
    name: courseContentReviewRoutesDefinitions.contentReview.name,
    component: () => import('./pages/CourseContentReviewPage.vue')
  },
  {
    path: courseContentReviewRoutesDefinitions.contentOverview.path,
    name: courseContentReviewRoutesDefinitions.contentOverview.name,
    component: () => import('./pages/ContentOverviewPage.vue')
  },
  {
    path: courseContentReviewRoutesDefinitions.reviewContent.path,
    name: courseContentReviewRoutesDefinitions.reviewContent.name,
    component: () => import('./pages/ReviewContentPage.vue')
  },
  {
    path: courseContentReviewRoutesDefinitions.kfkReport.path,
    name: courseContentReviewRoutesDefinitions.kfkReport.name,
    component: () => import('./pages/KfkPublishingReportPage.vue')
  },
  {
    path: courseContentReviewRoutesDefinitions.publishedVideos.path,
    name: courseContentReviewRoutesDefinitions.publishedVideos.name,
    component: () => import('./pages/PublishedVideosPage.vue')
  },
  {
    path: courseContentReviewRoutesDefinitions.homeInitFailed.path,
    name: courseContentReviewRoutesDefinitions.homeInitFailed.name,
    component: () => import('./pages/HomeInitFailedPage.vue')
  },
  {
    path: courseContentReviewRoutesDefinitions.manageUserAccess.path,
    name: courseContentReviewRoutesDefinitions.manageUserAccess.name,
    component: () => import('./pages/ManageUserAccessPage.vue')
  }
];
